/// <reference types="google.maps" />

import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAPS_DARK_MODE_STYLE } from "../../../helpers/MapStyles";
import { useLayout } from "../../../providers/LayoutProvider/LayoutProvider";

import { isDeviceLocationAvailable } from "../../../helpers/deviceHelpers";
import { Device } from "../Device";

const DeviceMap = (props: { device: Device }) => {
  const { darkMode } = useLayout();
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
  });

  const { lat, lng } = props.device;

  if (!isDeviceLocationAvailable(props.device)) {
    return <></>;
  }

  const center = {
    lat: Number(lat),
    lng: Number(lng),
  };

  const onLoad = (map: google.maps.Map) => {
    setTimeout(() => {
      map.panTo(center);
    }, 1);
  };

  return isLoaded ? (
    <GoogleMap
      id="deviceMap"
      mapContainerStyle={{ width: "100%", height: "300px" }}
      zoom={10}
      onLoad={onLoad}
      options={{
        styles: darkMode ? GOOGLE_MAPS_DARK_MODE_STYLE : null,
      }}
    >
      {<Marker position={center} />}
    </GoogleMap>
  ) : (
    <></>
  );
};

export default DeviceMap;
